import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
// import store from "../..";

const state = {
  salaries: [],
  totalRewards: 0,
  totalPenalties: 0,
  pagination: {},
  addStatus: false,
  addAllSalariesStatus: false,
  addSalaryRpType: false,
  editStatus: false,
  deleteStatus: false,
  deleteSalaryRpStatus: false,
  salaryStatus: false,
};
const getters = {
  getSalariesList: (state) => state.salaries,
  getSalary: (state) => state.salary,
  salariesPagination: (state) => state.pagination,
};
const actions = {
  getSalaries({ commit }, payload) {
    const params = new URLSearchParams();
    if (payload?.date) {
      params.append("date", payload.date);
    }
    if (payload?.page) {
      params.append("page", payload.page);
    }

    const url = `salaries?${params.toString()}`;
    console.log(url, "salary url");
    service.getFun(url).then(
      (obj) => {
        var result = obj?.data.data;
        const pageResult = {
          currentPage: obj?.data?.current_page,
          lastPage: obj?.data?.last_page,
          itemsPerPage: obj?.data?.per_page,
          total: obj?.data?.total,
        };
        commit("setPagination", pageResult);

        commit("setSalaries", result);
      },
      (error) => {
        console.log("salaries..." + error);
        toastError(error);
      }
    );
  },

  addSalary({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `salaries`, null, {
        action: "getSalaries",
      })
      .then(
        (result) => {
          if (result) {
            commit("addSalary", result.success);
            toast(result?.message);
          }
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  addAllSalaries({ commit }, payload) {
    service
      .postFun(payload, `bulk-salaries`, null, {
        action: "getSalaries",
      })
      .then(
        (result) => {
          commit("addAllSalary", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  addSalaryRpType({ commit }, payload) {
    service
      .postFun(payload, `salary-rptypes`, null, {
        action: "getSalaries",
      })
      .then(
        (result) => {
          commit("addSalaryRpType", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  async changeSalaryStatus({ commit }, payload) {
    const result = await service.postFun(
      payload,
      "change_salary_status",
      null,
      {
        action: "getSalaries",
      }
    );
    if (result) {
      commit("setSalaryStatus", result.success);
      toast(result.message);
    }
  },
  deleteSalary({ commit }, payload) {
    service
      .deleteFun(`salaries/${payload.payload}`, {
        action: "getSalaries",
      })
      .then(
        (result) => {
          commit("deleteSalaryStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteSalaryRp({ commit }, payload) {
    console.log(payload, "deleteSalary");
    service
      .postFun(payload, `salary-rptypes/delete`, null, {
        action: "getSalaries",
      })
      .then(
        (result) => {
          commit("deleteSalaryRpStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
};
const mutations = {
  setSalaries(state, Salaries) {
    state.salaries = Salaries;
  },
  addSalary(state, Status) {
    state.addStatus = Status;
  },
  addAllSalaries(state, Status) {
    state.addAllSalariesStatus = Status;
  },
  addSalaryRpType(state, Status) {
    state.addSalaryRpType = Status;
  },
  deleteSalaryStatus(state, Status) {
    state.deleteStatus = Status;
  },
  deleteSalaryRpStatus(state, Status) {
    state.deleteSalaryRpStatus = Status;
  },
  setSalaryStatus(state, Status) {
    state.salaryStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
